module.exports = __webpack_public_path__ + "static/media/Olukai.png.png.38732c83.webp";